import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-secondary-100">
      <div className="px-6 md:px-10 py-14 md:py-16">
        <div className="max-w-[1280px] mx-auto bg-background-50 rounded-[24px] px-6 md:px-12 py-12">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
            <div>
              <h3 className="font-heading text-xl font-bold text-foreground-950 mb-4">
                OOPBuy Guide
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                An independent educational guide providing comprehensive information about the OOPBuy Spreadsheet system. We do not process transactions — this site is for informational purposes only.
              </p>
            </div>

            <div>
              <h4 className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-4">
                Categories
              </h4>
              <ul className="space-y-2.5">
                {categories.map((cat) => (
                  <li key={cat.name}>
                    <a
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      {cat.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-4">
                Guides
              </h4>
              <ul className="space-y-2.5">
                <li>
                  <Link
                    to="/"
                    className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    What is OOPBuy Spreadsheet
                  </Link>
                </li>
                <li>
                  <Link
                    to="/oopbuy-spreadsheet-guide"
                    className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    Complete Guide &amp; How It Works
                  </Link>
                </li>
                <li>
                  <Link
                    to="/oopbuy-spreadsheet-buying-guide"
                    className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    Buying Tips &amp; Strategies
                  </Link>
                </li>
                <li>
                  <a
                    href="https://kaspreadsheet.com/"
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    Visit Official Platform
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-4">
                Legal
              </h4>
              <ul className="space-y-2.5">
                <li>
                  <span className="text-sm text-foreground-500">Privacy Policy</span>
                </li>
                <li>
                  <span className="text-sm text-foreground-500">Terms of Use</span>
                </li>
                <li className="pt-2">
                  <p className="text-xs text-foreground-500 leading-relaxed">
                    This site is an independent guide and is not affiliated with or endorsed by any specific platform.
                  </p>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} OOPBuy Spreadsheet Guide. All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100 hover:bg-background-200 text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer"
                aria-label="Visit official platform"
              >
                <i className="ri-external-link-line text-sm"></i>
              </a>
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100 hover:bg-background-200 text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer"
                aria-label="Share"
              >
                <i className="ri-share-line text-sm"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}